import DOMPurify from "dompurify";

/**
 * Server-stored HTML, rendered without running it (KIN-2043).
 *
 * The rich-text editors limit what a clinician can type, but anyone holding a valid token can POST
 * arbitrary HTML straight to the API and the backend stores it unchanged. That HTML then runs in
 * the browser of every colleague who opens the note or email: stored XSS. The endpoints are
 * tenant-scoped and `@Secured`, so the attacker is an insider or a stolen session rather than the
 * open internet — lower risk than externally sourced content, and still not something to leave in
 * a clinical system.
 *
 * One component rather than a sanitise call at each site, so a new render cannot quietly skip it:
 * the sanitising and the rendering arrive together or not at all.
 *
 * `ADD_DATA_URI_TAGS: ["img"]` matches TemplatePreview, which has sanitised since it was written.
 * Inline images are how the letter templates carry a practice logo, so stripping data URIs would
 * blank them.
 */
export const SafeHtml = ({ html, className, testId }) => (
  <div
    className={className}
    data-testid={testId}
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(html || "", { ADD_DATA_URI_TAGS: ["img"] }),
    }}
  />
);
